(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clay-product-features-interactive"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const card = event.target.closest('.hc-features__card')
    if (!card) return
    if (!window.Shopify || !window.Shopify.analytics || !window.Shopify.analytics.publish) return

    window.Shopify.analytics.publish('hey_clay:filter_link_click', {
      filter_type: card.dataset.filterType,
      filter_value: card.dataset.filterValue,
      filter_source: 'product_features',
      item_id: card.dataset.itemId,
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
